import l from "./index253.js";
import { resolveComponent as n, createElementBlock as p, createCommentVNode as o, openBlock as t, createBlock as s, createVNode as r, withCtx as m, createTextVNode as c, toDisplayString as k } from "vue";
import u from "./index231.js";
const h = ["data-component"];
function _(e, f, g, V, b, x) {
  const a = n("ms-headline"), i = n("cs-link-group"), d = n("cs-expander");
  return e.links && e.links.length ? (t(), p("div", {
    key: 0,
    "data-component": e.$options.name
  }, [
    e.headline ? (t(), s(a, {
      key: 0,
      class: "mb-20",
      type: "h3"
    }, {
      default: m(() => [
        c(k(e.headline), 1)
      ]),
      _: 1
    })) : o("", !0),
    r(i, {
      links: e.links,
      amountVisibleLinks: e.amountVisibleLinks,
      hasMaxColumns: ""
    }, null, 8, ["links", "amountVisibleLinks"]),
    e.showExpander ? (t(), s(d, {
      key: 1,
      class: "mt-24",
      expanded: e.expanded,
      "onUpdate:expanded": e.toggle
    }, null, 8, ["expanded", "onUpdate:expanded"])) : o("", !0)
  ], 8, h)) : o("", !0);
}
const $ = /* @__PURE__ */ u(l, [["render", _]]);
export {
  $ as default
};
